module.exports = __webpack_public_path__ + "static/media/youtube_icon.b64320a1.png";